import {InformeService} from "../informe-api";
import diccionario from "@/imageDictionary.js";

export function informe2026(constantes, anio, anioAnterior, instalacion, organizacion, datos) {
    const informe = new InformeService(constantes);
    let content = [
        {
      table: {
        widths: ["25%","50%", "25%"],
        heights: [50, 10, 10, 40, 30, 80, 50, 80, 50, 300],
        body: [
            [
                {
                    rowSpan:2,
                    image: diccionario.logoBanderaAzulDos,
                    alignment: "left",
                    fit: [124, 124]
                },
                {},
                {
                    rowSpan: 10,
                    text: anio,
                    fontSize: 40,
                    bold: true,
                    alignment: "center",
                    fillColor: "#5084bc",
                    color: "#ffffff"
                }
            ],
            [
                '',
                {
                    text: "VI Categoría:\n Cambio Climático",
                    fontSize: 25,
                    bold: true,
                    alignment: "center",
                    color: "#1f497d"
                },
                ''
            ],
            [
                {
                    colSpan: 3,
                    text: "Programa Bandera Azul Ecológica",
                    fontSize: 20,
                    bold: true,
                    alignment: "center",
                    fillColor: "#38849c",
                    color: "#e2e6df"
                }
            ],
            [
                {},
                {},
                {}
            ],
            [
                {},
                {
                    text: "Informe Final Año " + anio,
                    alignment: "center",
                    fontSize: 26,
                    bold: true,
                    color: "#1f497d"
                },
                {}
            ],
            [
                {},
                {},
                {}
            ],
            [
                {},
                {
                    text: `${instalacion.codigoPbae} ${instalacion.nombre}`,
                    alignment: "center",
                    fontSize: 26,
                    bold: true,
                    color: "#1f497d"
                },
                {}
            ],
            [
                {},
                {},
                {}
            ],
            [
                {},
                {
                    image: datos.orgaLogo,
                    alignment: "center",
                    width: 200
                },
                {}
            ], 
            [
                {},
                {},
                {}
            ],
        ]
      },
      layout: {
        defaultBorder: false
      }
    },

    {
      text: "",
      alignment: "center",
      fontSize: 26,
      bold: true,
      pageBreak: "after",
      color: "#4f81bd"
    },
        //Fin de la Portada del informe
        {
            text: "Recomendaciones para el adecuado llenado de este documento:",
            alignment: "center",
            bold: true,
            margin: [0, 10, 0, 0],
            fontSize: 14
        },
        {
            ul: [
                {
                    text: "Previo a completarlo, se debe realizar lectura completa del Manual de Procedimiento de la Categoría Cambio Climático, versión XIII2025.",
                    margin: [70, 10, 60, 0]
                },
                {
                    text: "Las imágenes que coloquen como evidencias deben ser 100% nítidas y leíbles, que permitan su comprensión. ",
                    margin: [70, 10, 60, 0]
                },
                {
                    text: "Se debe revisar cuando convierten el documento tipo Word a PDF, para que la calidad de las imágenes se conserve y cumplir con lo solicitado en el punto anterior.",
                    margin: [70, 10, 60, 0]
                },
                {
                    text: "En los espacios correspondientes a cada parámetro y subparámetro del formato de informe final, deben presentar la información solicitada, con las evidencias que permitan demostrar las acciones realizadas sin hacer una mezcla de información de diversos parámetros.",
                    margin: [70, 10, 60, 0]
                },
                {
                    text: "En los espacios para incluir evidencias, pueden ajustarlos según el tamaño de estas.",
                    margin: [70, 10, 60, 0]
                },
                {
                    text: "Todas las actividades y acciones por contemplar en el Informe Final deben corresponder al año de inscripción.",
                    margin: [70, 10, 60, 0]
                },
                {
                    text: "Está prohibido anexos o enlaces para verificar o complementar la información que quieren presentar.",
                    margin: [70, 10, 60, 0]
                },
                {
                    text: "No deben alterar elementos de forma ni estructura de este formato.  Si consideran que no les aplica algún apartado, indicar “No aplica” y la razón por la cual consideran que no les aplica. No deben eliminar el apartado. ",
                    margin: [70, 10, 60, 0]
                },
                {
                    text: "Con dos fotografías de la actividad que describen o bien dos diapositivas de las presentaciones en el caso de charlas impartidas es suficiente, eso sí que evidencien los contenidos tratados y que estén alineados con el parámetro. ",
                    margin: [70, 10, 60, 0]
                },
                {
                    text: "En el caso que sean muchas las personas participantes en una actividad, al presentar la lista de asistencia es solo una muestra de una página, no deben poner todo el listado de quienes participaron. Siempre y cuando en esa página está la información del representante de la sede.",
                    margin: [70, 10, 60, 0]
                },
                {
                    text: "Para la anotación de las cifras de los consumos como separador de decimales deben utilizar la coma (,) y las cifras de grandes cantidades se deben agrupar en conjuntos de 3, separados por espacios.",
                    margin: [70, 10, 60, 0]
                },
                {
                    text: "En algunas tablas, se encuentran filas de color gris, que corresponden a ejemplos con el fin de que sirvan de guía para completar lo que se solicita.",
                    margin: [70, 10, 60, 0]
                },
                {
                    text: "En los cuadros de reducción, se identifica con la letra “A” la columna en la cual se requiere los datos de consumo del año anterior y con la letra “B” los del año de participación.",
                    margin: [70, 10, 60, 0]
                },
                {
                    text: "El tamaño máximo del informe final a subir en el sistema debe ser de 10 MB, sin embargo, si excede ese tamaño se debe subir entre las 5:00 pm. a 7:30 am.",
                    margin: [70, 10, 60, 0]
                },
                {
                    text: "El nombre del archivo para subir y enviar el informe final debe ir de la siguiente forma: Informe final PBAE CCC año + código comité + nombre organización + nombre sede",
                    margin: [70, 10, 60, 0],
                    pageBreak: "after"
                }
            ]
        },
        // Fin de la página recomendaciones de llenado
        {
            text: "Contenido",
            alignment: "left",
            bold: true,
            color: "#4f81bd",
            fontSize: 14
        },
        {
            stack: [
                {text: "Generalidades de la Organización", margin: [20, 10, 60, 0]},
                {text: "Resumen Ejecutivo", margin: [20, 10, 60, 0]},
                {text: "Información requerida por parámetro", margin: [20, 10, 60, 0]},

                {text: "Parámetro N°1: Cumplimiento Legal", margin: [50, 10, 60, 0]},
                {text: "Parámetro N°2: Combustibles Fósiles", margin: [50, 10, 60, 0]},
                {text: "Parámetro N°3: Agua", margin: [50, 10, 60, 0]},
                {text: "Parámetro N°4: Tratamiento de Aguas Residuales", margin: [50, 10, 60, 0]},
                {text: "Parámetro N°5: Energía Eléctrica", margin: [50, 10, 60, 0]},
                {text: "Parámetro N°6: Gestión de Residuos", margin: [50, 10, 60, 0]},
                {text: "Parámetro N°7: Gases Refrigerantes", margin: [50, 10, 60, 0]},
                {text: "Parámetro N°8: Compras Sostenibles", margin: [50, 10, 60, 0]},
                {text: "Parámetro N°9: Adaptación al Cambio Climático", margin: [50, 10, 60, 0]},
                {text: "Parámetro N°10: Compensación Ambiental", margin: [50, 10, 60, 0]},

                {text: "Gradación de Estrellas", margin: [20, 10, 60, 0]},

                {text: "Una estrella blanca", margin: [50, 10, 60, 0]},
                {text: "Dos estrellas blancas", margin: [50, 10, 60, 0]},
                {text: "Tres estrellas blancas", margin: [50, 10, 60, 0]},
                {text: "Cuatro estrellas blancas", margin: [50, 10, 60, 0]},
                {text: "Cinco estrellas blancas", margin: [50, 10, 60, 0]},
                {text: "Seis estrellas blancas", margin: [50, 10, 60, 0]},
                {text: "Estrella Verde", margin: [50, 10, 60, 0]},
                {text: "Estrella Plateada", margin: [50, 10, 60, 0]}
            ],
            pageBreak: "after"
        },
        // Fin de la tabla de contenido
        {
            text: "1. Generalidades de la Organización",
            alignment: "left",
            bold: true,
            margin: [0, 10, 0, 0]
        },
        {
            ul: [
                {text: "", margin: [70, 10, 60, 0]}
            ]
        },
        {
            table: {
                widths: ["50%", "50%", "0%"],
                body: [
                    [
                        {
                            text: "Nombre de la Organización",
                            alignment: "left",
                            fillColor: "#8db3e2"
                        },
                        {text: datos.organizacionNombre}
                    ],
                    [
                        {text: "Nombre de la Sede", alignment: "left", fillColor: "#8db3e2"},
                        {text: instalacion.nombre}
                    ],
                    [
                        {text: "Código de Comité", alignment: "left", fillColor: "#8db3e2"},
                        {text: instalacion.codigoPbae}
                    ],
                    [
                        {
                            text: "Ubicación de la Sede (Provincia, Cantón, Distrito)",
                            alignment: "left",
                            fillColor: "#8db3e2"
                        },
                        {text: `${instalacion.ubicacion} ${instalacion.direccion}`}
                    ],
                    [
                        {text: "Cantidad de colaboradores/as", alignment: "left", fillColor: "#8db3e2"},
                        {text: instalacion.cantidadPersonal}
                    ],
                    [
                        {
                            text: "Primera vez que presenta el Informe Final (Si/No)",
                            alignment: "left",
                            fillColor: "#8db3e2"
                        },
                        {text: instalacion.tiempoEnPrograma > 0 ? "No" : "Si"}
                    ],
                ]
            }
        },
        {
            table: {
                widths: ["100%"],
                body: [
                    [
                        {
                            text: "Historial de participación en la Categoría Cambio Climático \n(Si es primera vez que participan no completar. Para el histórico se contemplan 5 años anteriores) ",
                            alignment: "center",
                            fillColor: "#8db3e2",
                        }
                    ]
                ]
            }
        },
        informe.historialParticipacionCambioClimatico2026(datos.historialEstrella),
        {
            text: "Foto que demuestre, la iza o exhibición de la bandera, del galardón PBAE obtenido el año anterior ",
            alignment: "center",
            fillColor: "#8db3e2",
            colSpan: 2
        },
        informe.informeGalardon(datos.galardon),
        {
            margin: [20, 50, 20, 40, 20],
            text: [
                {text: "2. Resumen Ejecutivo: ", bold: true}
            ]
        },
        {
            table: {
                widths: ["10%", "20%", "70%"],
                body: [
                    [
                        {
                            text: "Indique el alcance de la implementación del PBAE (límites físicos de aplicación: Edificio, plantel sedes, otros) ",
                            alignment: "center",
                            fillColor: "#8db3e2",
                            colSpan: 2
                        },
                        "",
                        {text: instalacion.alcance}
                    ],
                    [
                        {
                            text: "Describa en que consiste la actividad sustantiva que desarrolla la organización ",
                            alignment: "center",
                            fillColor: "#8db3e2",
                            colSpan: 2
                        },
                        "",
                        {text: datos.descripcionOrg}
                    ],
                    [
                        {
                            text: "Describa aspectos de la sede que considere relevantes de ser contemplados por el evaluador al momento de evaluar el informe final ",
                            alignment: "center",
                            fillColor: "#8db3e2",
                            colSpan: 2
                        },
                        "",
                        {text: instalacion.detalle}
                    ]
                ]
            }
        },
        {
            text: "Información requerida por parámetro",
            bold: true,
            margin: [0, 50, 20, 40, 0],
            fontSize: 14,
            color: "#4f81bd",
            pageBreak: "before",
        },
        ///////////////////////////////////////////Cumplimiento Legal/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        {
            text: "Parámetro N°1.: Cumplimiento Legal",
            alignment: "center",
            bold: true,
            margin: [50, 20, 40, 0],
            color: "#4f81bd"
        },
        {
            ul: [
                {text: "", margin: [70, 10, 60, 0]}
            ]
        },
        {
            text: "1.1 Cuestionario para autoevaluar el cumplimiento legal",
            alignment: "left",
            bold: true,
            margin: [0, 0, 40, 0]
        },
        {
            text: 'El documento se debe descargar en el apartado Recursos del SIBAE.',
            alignment: "left",
            margin: [5, 20, 40, 0]
        },
        {
            text: 'Seguir las indicaciones para el llenado del cuestionario, que están en la pestaña “Indicaciones Generales” del Excel.',
            alignment: "left",
            margin: [5, 0, 40, 0]
        },
        {
            text: 'Sedes que participan de otro país, que no sea Costa Rica, debe adaptar el cuestionario a la legislación propia de su nación.',
            alignment: "left",
            margin: [5, 0, 40, 20]
        },
        informe.envidenciaSimple(datos.inscripcionLegal),
        ///////////////////////////////////////////Combustibles fósiles/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        {
            pageBreak: "before",
            text: "Parámetro N°2: Combustibles Fósiles",
            alignment: "center",
            bold: true,
            margin: [50, 20, 40, 0],
            color: '#4f81bd'
        },
        informe.tipoCombustibles2023(datos, instalacion, anio, anioAnterior),
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        {
            pageBreak: "before",
            text: "3. Agua", alignment: "center", bold: true, margin: [50, 20, 40, 0]
        },
        {
            text: "3.1 Verificación de la calidad de agua potable para consumo humano",
            alignment: "left",
            bold: true,
            margin: [50, 20, 40, 20]
        },
        informe.tablaEvidenciasAgua2025(datos.potabilidadAgua, datos.potabilidadAguaPropia, datos.justPotabilidadAgua),
        {
            text: '', alignment: 'left', bold: true, margin: [50, 20, 40, 20]
        },
        informe.tablaEvidencias(datos.docsJustCalidadAgua),
        {
            text: "3.2 Determinación del consumo de agua para uso humano y el proceso productivo.",
            alignment: "left",
            bold: true,
            margin: [50, 20, 40, 20]
        },
        {
            text: "Cuadro N°8",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 20]
        },
        {
            text: `Consumo Mensual de Agua del año anterior al de participación ${anioAnterior}`,
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 0]
        },
        informe.tablaConsumo2025Agua(datos.consumoAguaAnterior, constantes.indicadorAgua, anioAnterior, anio, "#fac090"),
        {
            text: "", alignment: "left", bold: true, margin: [50, 20, 40, 20]
        },
        informe.justificacionReduccion2025(datos.justAguaConsAnte, "#fac090", "Justificación por ausencia de datos o consumo igual a cero, y evidencia de la gestión realizada para obtener los datos"),
        {
            pageBreak: "before",
            text: "Cuadro N°9",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 20]
        },
        {
            text: `Consumo mensual de agua del año de participación (${anio})`,
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 0]
        },
        informe.tablaConsumo2025Agua(datos.consumoAguaActual, constantes.indicadorAgua, anio, anio, "#8db3e2"),
        {
            text: "", alignment: "left", bold: true, margin: [50, 20, 40, 20]
        },
        informe.justificacionReduccion2025(datos.justAguaCons, "#8db3e2", "Justificación por ausencia de datos o consumo igual a cero, y evidencia de la gestión realizada para obtener los datos"),
        informe.tablaEvidencias(datos.docsJustConsumoAgua),
        // ===================== CUADRO 10 =======================
        ...(
        (datos.reduccionAgua && datos.reduccionAgua.length > 0)
            ? [
                // CUADRO N°10-a
                {
                pageBreak: "before",
                text: "3.3 Reducción en el consumo del agua para uso humano y el proceso productivo mayor a un 1%",
                alignment: "left",
                bold: true,
                margin: [50, 20, 40, 20]
                },
                {
                text: "Cuadro N°10-a",
                color: "#4f81bd",
                alignment: "center",
                fillColor: "#4f81bd",
                italics: true,
                margin: [50, 20, 40, 20]
                },
                {
                text: `Comparación de consumos de agua año ${anioAnterior} con respecto al año ${anio}`,
                color: "#4f81bd",
                alignment: "center",
                fillColor: "#4f81bd",
                italics: true,
                margin: [50, 0, 40, 0]
                },
                informe.reduccionConsumo2022(datos.reduccionAgua, constantes.indicadorAgua, anio, anioAnterior),
                {
                text: "Siglas, abreviaturas y símbolos",
                alignment: "left",
                bold: true,
                decoration: "underline",
                italics: true,
                margin: [50, 20, 40, 0]
                },
                { text: "*: Multiplicación.", alignment: "left", italics: true, margin: [50, 0, 40, 0] },
                { text: "/: División.", alignment: "left", italics: true, margin: [50, 0, 40, 0] },
                { text: "L: Litros.", alignment: "left", italics: true, margin: [50, 0, 40, 20] },
                {
                text: "Nota: Los factores de conversión incluidos en este cuadro, para obtener las equivalencias, son un valor de referencia.",
                alignment: "left",
                italics: true,
                margin: [50, 0, 40, 20]
                },
                informe.justificacionReduccion2022(datos.justAgua, "#8db3e2", "Justificación en caso de: 1) aumento del consumo total o algún tipo de uso, 2) mismo consumo del año anterior, 3) ausencia de datos o 4) datos igual a cero"),
                informe.tablaEvidencias(datos.docsJustReducciongua),
                { text: "", alignment: "left", bold: true, margin: [50, 20, 40, 20] },
                informe.evidenciaJustificacion(datos.justAnioAgua)
            ]
            : (
                //  CUADRO N°10-b SI HAY DATOS PARA COMPARAR
                (informe.comparacionConsumoAgua2025(datos.consumoAguaActual, constantes.indicadorAgua, datos.consumoAguaAnterior) || []).length > 0
                ? [
                    {
                        pageBreak: "before",
                        text: "3.3 Reducción en el consumo del agua para uso humano y el proceso productivo mayor a un 1%",
                        alignment: "left",
                        bold: true,
                        margin: [50, 20, 40, 20]
                    },
                    {
                        text: "Cuadro N°10-b",
                        color: "#4f81bd",
                        alignment: "center",
                        fillColor: "#4f81bd",
                        italics: true,
                        margin: [50, 20, 40, 20]
                    },
                    {
                        text: `Comparación de consumos de agua durante el año ${anio}`,
                        color: "#4f81bd",
                        alignment: "center",
                        fillColor: "#4f81bd",
                        italics: true,
                        margin: [50, 0, 40, 0]
                    },
                    ...informe.comparacionConsumoAgua2025(
                        datos.consumoAguaActual,
                        constantes.indicadorAgua,
                        datos.consumoAguaAnterior,
                        anio
                    ),
                    {
                        text: "Siglas, abreviaturas y símbolos",
                        alignment: "left",
                        bold: true,
                        decoration: "underline",
                        italics: true,
                        margin: [50, 20, 40, 0]
                    },
                    { text: "*: Multiplicación.", alignment: "left", italics: true, margin: [50, 0, 40, 0] },
                    { text: "/: División.", alignment: "left", italics: true, margin: [50, 0, 40, 0] },
                    { text: "L: Litros.", alignment: "left", italics: true, margin: [50, 0, 40, 20] },
                    {
                        text: "Nota: Los factores de conversión incluidos en este cuadro, para obtener las equivalencias, son un valor de referencia.",
                        alignment: "left",
                        italics: true,
                        margin: [50, 0, 40, 20]
                    },
                    informe.justificacionReduccion2022(datos.justAgua, "#8db3e2", "Justificación en caso de: 1) aumento del consumo total o algún tipo de uso, 2) mismo consumo del año anterior, 3) ausencia de datos o 4) datos igual a cero:"),
                    informe.tablaEvidencias(datos.docsJustReducciongua),
                    { text: "", alignment: "left", bold: true, margin: [50, 20, 40, 20] },
                    informe.evidenciaJustificacion(datos.justAnioAgua)
                    ]
                : [
                    //  CASO POR DEFECTO: Mostrar CUADRO 10-a VACÍO
                    {
                        pageBreak: "before",
                        text: "3.3 Reducción en el consumo del agua para uso humano y el proceso productivo mayor a un 1%",
                        alignment: "left",
                        bold: true,
                        margin: [50, 20, 40, 20]
                    },
                    {
                        text: "Cuadro N°10-a",
                        color: "#4f81bd",
                        alignment: "center",
                        fillColor: "#4f81bd",
                        italics: true,
                        margin: [50, 20, 40, 20]
                    },
                    {
                        text: `Comparación de consumos de agua año ${anioAnterior} con respecto al año ${anio}`,
                        color: "#4f81bd",
                        alignment: "center",
                        fillColor: "#4f81bd",
                        italics: true,
                        margin: [50, 0, 40, 0]
                    }
                    ]
            )
        ),
        {
            pageBreak: "before",
            text: "3.4 Educación ambiental", alignment: "left", bold: true, margin: [50, 20, 40, 20]
        },
        {
            text: "Cuadro N°11",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 20]
        },
        {
            text: `Educación Ambiental ${anio}`,
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 0]
        },
        informe.educacionAmbiental2023(datos.educacionAgua),
        {
            pageBreak: "before",
            text: "3.5 Acciones de registro, reducción y control (Dos acciones)", alignment: "left", bold: true, margin: [50, 20, 40, 20]
        },
        {
            text: "Cuadro N°12",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 20]
            },
        {
            text: "Acciones de registro, reducción y control",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 0]
        },
        informe.tablaAccionesReduccion2022(datos.accionReducAgua),
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        {
            pageBreak: "before",
            text: "Parámetro N°4. Tratamiento Aguas Residuales",
            alignment: "center",
            bold: true,
            margin: [50, 20, 40, 0]
        },
        {
            text: "4.1 Identificación del sistema utilizado en la sede para el tratamiento de aguas residuales.",
            alignment: "left",
            bold: true,
            margin: [50, 20, 40, 0]
        },
        {
            text: "Completar según el sistema que le aplique a la sede. En los casos que la sede cuente con más de un sistema, solamente debe completar la información de uno de ellos.",
            alignment: "left",
            bold: false,
            margin: [50, 5, 40, 0]
        },
        informe.identificacionStar2025(datos.tipoSistemaTrat),
        {
            pageBreak: "before",
            text: "4.2 Educación ambiental (Una actividad)", alignment: "left", bold: true, margin: [50, 20, 40, 20]
        },
        {
            text: "Cuadro N°13",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 20]
        },
        {
            text: `Educación Ambiental ${anio}`,
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 0]
        },
        informe.educacionAmbiental2023(datos.educcacionAguasRes),
        {
            pageBreak: "before",
            text: "4.3 Acciones de registro, reducción y control (Dos acciones)", alignment: "left", bold: true, margin: [50, 20, 40, 20]
        },
        {
            text: "Cuadro N°14",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 0]
        },
        {
            text: `Acción de registro, reducción y control`,
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 15]
        },
        informe.tablaAccionesReduccion2022(datos.accionReducAguResid),
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        {
            pageBreak: "before",
            text: "Parámetro N°5: Energía Eléctrica ",
            alignment: "center",
            bold: true,
            margin: [50, 20, 40, 0],
            color: "#4f81bd"
        },
        {
            text: "5.1 Determinación del consumo de energía eléctrica",
            alignment: "left",
            bold: true,
            margin: [50, 20, 40, 0]
        },
        {
            text: "Cuadro N°15",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 0]
        },
        {
            text: `Consumo mensual de electricidad del año anterior al de participación (${anioAnterior})`,
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 15]

        },
        informe.tablaConsumo2025(datos.consumoEnergiaAnterior, constantes.indicadorEnergia, anioAnterior, anio, "#fac090"),
        [
            {
                text: "Símbolos a utilizar:", alignment: "left", fontSize: 10, margin: [0, 0, 40, 0]
            },
            {
                text: ", : Separador de decimales", alignment: "left", fontSize: 8, margin: [0, 0, 40, 20]
            }
        ],
        informe.justificacionReduccion2025(datos.justEnerConsAnte, "#fac090", "Justificación por ausencia de datos o consumo igual a cero, y evidencia de la gestión realizada para obtener los datos:"),
        {
            pageBreak: "before",
            text: "Cuadro N°16",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 0]
        },
        {
            text: ` Consumo mensual de electricidad del año de participación (${anio})`,
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 15]

        },
        informe.tablaConsumo2025(datos.consumoEnergiaActual, constantes.indicadorEnergia, anio, anio, "#8db3e2"),
        [
            {
                text: "Símbolos a utilizar:",
                alignment: "left",
                fontSize: 10,
                margin: [0, 0, 40, 0],
                decoration: "underline"
            },
            {
                text: ", : Separador de decimales", alignment: "left", fontSize: 8, margin: [0, 0, 40, 20]
            }
        ],
        informe.justificacionReduccion2025(datos.justEnerCons, "#8db3e2", "Justificación por ausencia de datos o consumo igual a cero, y evidencia de la gestión realizada para obtener los datos:"),
        informe.tablaEvidencias(datos.docsJustConsumoEnergia),
        {
            pageBreak: "before",
            text: "5.2 Reducción en el consumo de energía eléctrica mayor al 1% respecto al año anterior",
            alignment: "left",
            bold: true,
            margin: [50, 20, 40, 0]
        },
        {
            text: "Cuadro N°17-a",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 0]
        },
        {
            text: `Comparación de consumos de energía eléctrica año ${anioAnterior}, con respecto año ${anio}`,
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 15]

        },
        informe.reduccionConsumo2025(datos.reduccionEnergia, constantes.indicadorEnergia, anio, anioAnterior),
        {
            text: "Siglas, abreviaturas y símbolos",
            alignment: "left",
            decoration: "underline",
            italics: true,
            margin: [0, 0, 40, 0],
            fontSize: 12
        },
        {
            text: ",: Separador de decimales",
            alignment: "left",
            bold: true,
            italics: true,
            margin: [5, 0, 0, 0],
            fontSize: 10
        },
        {
            text: "*: Multiplicación.", alignment: "left", bold: true, italics: true, margin: [5, 0, 0, 0], fontSize: 10
        },
        {
            text: "KW/h: Kilowatt hora", alignment: "left", italics: true, margin: [5, 0, 0, 0], fontSize: 10
        },
        {
            text: "Ton CO2 eq: Toneladas de dióxido de carbono equivalente." + anio,
            alignment: "left",
            italics: true,
            margin: [5, 0, 0, 20],
            fontSize: 10
        },
        informe.justificacionReduccion2025(datos.justEnergia, "#8db3e2", "Justificación en caso de: 1) aumento del consumo, 2) mismo consumo del año anterior, 3) ausencia de datos o 3) datos igual a cero:"),
        informe.tablaEvidencias(datos.docsJustReduccionEnergia),
        informe.comparacionConsumo2025(datos.consumoEnergiaActual, constantes.indicadorEnergia, datos.consumoEnergiaAnterior, `Comparación de consumos de energía eléctrica año ${anio}`, '17-b', datos.justEnergia, "Justificación en caso de: 1) aumento del consumo total o algún tipo de combustible fósil, 2) ausencia de datos o 3) datos igual a cero: "),
        {
            pageBreak: "before",
            text: "5.3 Educación ambiental (Dos actividades) ", alignment: "left", bold: true, margin: [50, 20, 40, 20]
        },
        {
            text: "Cuadro N°18",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 0]
        },
        {
            text: `Educación Ambiental ${anio}`,
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 20]
        },
        informe.educacionAmbiental2025(datos.educacionEnergia),
        {
            pageBreak: "before",
            text: "5.4 Acciones de registro, reducción y control (Una acción)", alignment: "left", bold: true, margin: [50, 20, 40, 20]
        },
        {
            text: "Cuadro N°19",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 20]
        },
        {
            text: `Acción de registro, reducción y control`,
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 0]
        },
        informe.tablaAccionesReduccion2022(datos.accionReduccionEnergia),
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        {
            pageBreak: "before",
            text: "6. Gestión de Residuos", alignment: "center", bold: true, margin: [50, 20, 40, 0]
        },
        {
            text: "6.1 Determinación del consumo de papel", alignment: "left", bold: true, margin: [50, 20, 40, 20]
        },
        {
            text: "Cuadro N°20",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 20]
        },
        {
            text: `Consumo mensual de papel de oficina del año anterior al de participación (${anioAnterior})`,
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 0]
        },
        informe.tablaConsumo2022(datos.consumoResiduosAnterior, constantes.indicadorResiduos, anioAnterior, anio, "#fac090"),
        {
            text: "Nota: Una resma equivale a 500 hojas", alignment: "left", margin: [50, 20, 40, 20]
        },
        informe.justificacionReduccion2022(datos.justResiduConsAnte, "#fac090", "Justificación por ausencia de datos o consumo igual a cero, y evidencia de la gestión realizada para obtener los datos:"),
        {
            pageBreak: "before",
            text: "Cuadro N°21",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 20]
        },
        {
            text: `Consumo mensual de papel de oficina del año de participación (${anio})`,
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 0]
        },
        informe.tablaConsumo2022(datos.consumoResiduosActual, constantes.indicadorResiduos, anio, anio, "#8db3e2"),
        {
            text: "Nota: Una resma equivale a 500 hojas", alignment: "left", margin: [50, 20, 40, 20]
        },
        informe.justificacionReduccion2022(datos.justConsPapel, "#8db3e2", "Justificación por ausencia de datos o consumo igual a cero, y evidencia de la gestión realizada para obtener los datos:"),
        informe.tablaEvidencias(datos.docsJustConsumoPapel),
        {
            pageBreak: "before",
            text: "6.2. Reducción del uso de papel en al menos un 1% con respecto al año anterior",
            alignment: "left",
            bold: true,
            margin: [50, 20, 40, 20]
        },
        {
            text: "Cuadro N°22-A",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 20]
        },
        {
            text: `Comparación del consumo de papel año ${anioAnterior} con respecto año ${anio}`,
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 0]
        },
        informe.reduccionConsumo2022(datos.reduccionPapel, constantes.indicadorResiduos, anio, anioAnterior, instalacion),
        {
            text: "", alignment: "left", bold: true, margin: [50, 20, 40, 20]
        },
        informe.justificacionReduccion2022(datos.justResPapel, "#8db3e2", "Justificación en caso de: 1) aumento del consumo, 2) mismo consumo del año anterior, 3) ausencia de datos o 4) datos igual a cero:"),
        informe.tablaEvidencias(datos.docsJustReduccionPapel),
        informe.comparacionConsumo2025(datos.consumoResiduosActual, constantes.indicadorResiduos, datos.consumoResiduosAnterior, `Comparación de consumos de papel año ${anio}.`,'22-B', datos.justResPapel, "Justificación en caso de: 1) aumento del consumo de papel, 2) ausencia de datos o 3) datos igual a cero:"),
        informe.tablaEvidencias(datos.docsJustReduccionPapel),
        {
            pageBreak: "before",
            text: "6.3. Medición y comparación de la generación de Residuos Sólidos Valorizables",
            alignment: "left",
            bold: true,
            margin: [50, 20, 40, 20]
        },
        {
            text: "Cuadro N°23",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 20]
        },
        {
            text: `Medición de la generación de residuos sólidos valorizables del año anterior de participación (${anioAnterior})`,
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 0]
        },
        informe.tablaResidSoli(datos.consumoValoAnterior, constantes.indicadorResiduos, "#fac090", instalacion),
        {
            text: "", alignment: "left", bold: true, margin: [50, 20, 40, 20]
        },
        informe.justificacionReduccion2022(datos.justConsValoAnte, "#fac090", "Justificación por ausencia de datos o generación igual a cero (en uno o varios tipos de residuos), y evidencia de la gestión realizada para obtener los datos:"),
        {
            pageBreak: "before",
            text: "Cuadro N°24",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 20]
        },
        {
            text: `Medición de la generación de residuos sólidos valorizables del año de participación (${anio})`,
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 0]
        },
        informe.tablaResidSoli(datos.consumoValoActual, constantes.indicadorResiduos, anio, "#8db3e2", instalacion),
        {
            text: "Nota: A excepción del tipo de residuo valorizable Chatarra y metales, esta clasificación de residuos valorizables responde a la Estrategia Nacional de Separación, Recuperación y Valorización de Residuos.",
            alignment: "left",
            margin: [50, 20, 40, 20]
        },
        {
            text: "", alignment: "left", bold: true, margin: [50, 20, 40, 20]
        },
        informe.justificacionReduccion2022(datos.justConsValo, "#8db3e2", "Justificación por ausencia de datos o generación igual a cero (en uno o varios tipos de residuos), y evidencia de la gestión realizada para obtener los datos:"),
        informe.tablaEvidencias(datos.docsJustConsumoValor),
        {
            text: "", alignment: "left", bold: true, margin: [50, 20, 40, 20]
        },
        informe.evidenciaJustificacion(datos.justAnioResiduos),
        {
            pageBreak: "before",
            text: "6.4. Reducción de residuos sólidos valorizables en al menos un 1%, con respecto al año anterior de participación",
            alignment: "left",
            bold: true,
            margin: [50, 20, 40, 20]
        },
        informe.comparResid2025(datos.resValorizales, datos.reduccTrimVal, anio, anioAnterior),
        informe.comparacionConsumo2025(datos.consumoValoActual, constantes.indicadorResiduosValorizables, datos.consumoValoAnterior, `Comparación de generación residuos sólidos valorizables del año ${anio}`,'25-B', datos.justResiduos, "Justificación en caso de no lograrse la reducción, ausencia de datos:"),
        {
            text: "", alignment: "left", bold: true, margin: [50, 20, 40, 20]
        },
        informe.justificacionReduccion2022(datos.justResiduos, "#92cddc", "Justificación en caso de: 1) aumento en la generación total o algún tipo de residuo, 2) misma generación del año anterior, 3) ausencia de datos o 4) datos igual a cero:"),
        informe.tablaEvidencias(datos.docsJustReduccionValor),
        {
            text: "", alignment: "left", bold: true, margin: [50, 20, 40, 20]
        },
        informe.residuoOrganicosDisposicion(datos.resValorizales, "#92cddc"),
        {
            pageBreak: "before",
            text: "6.5. Medición y comparación de la generación de residuos sólidos no valorizables",
            alignment: "left",
            bold: true,
            margin: [50, 20, 40, 20]
        },
        {
            text: "Cuadro N°26",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 20]
        },
        {
            text: `Medición de la generación de residuos sólidos no valorizables del año anterior de participación (${anioAnterior})`,
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 0]
        },
        informe.tablaResidSoli(datos.consumoNoValoAnterior, constantes.indicadorResiduos, anioAnterior, "#fac090", instalacion),
        {
            text: "", alignment: "left", bold: true, margin: [50, 20, 40, 20]
        },
        informe.justificacionReduccion2022(datos.justConsNoValoAnte, "#fac090", "Justificación por ausencia de datos o generacón igual a cero, y evidencia de la gestión realizada para obtener los datos:"),
        {
            pageBreak: "before",
            text: "Cuadro N°27",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 20]
        },
        {
            text: `Medición de la generación de residuos sólidos no valorizables del año de participación (${anio})`,
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 0]
        },
        informe.tablaResidSoli(datos.consumoNoValolActual, constantes.indicadorResiduos, anio, "#8db3e2", instalacion),
        {
            text: "", alignment: "left", bold: true, margin: [50, 20, 40, 20]
        },
        informe.justificacionReduccion2022(datos.justConsNoValo, "#8db3e2", "Justificación por ausencia de datos o generacón igual a cero, y evidencia de la gestión realizada para obtener los datos:"),
        informe.tablaEvidencias(datos.docsJustConsumoNoValor),
        {
            pageBreak: "before",
            text: "6.6. Reducción de residuos no valorizables en al menos un 1%, con respecto al año anterior de participación",
            alignment: "justify",
            bold: true,
            margin: [50, 0, 40, 0]
        },
        {
            text: "Cuadro N°28-A",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 20]
        },
        {
            text: `Comparación de generación residuos no valorizables del año ${anioAnterior} con respecto al año ${anio}`,
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 0]
        },
        informe.comparResidNoVa(datos.resNoValorizales, true, anio, anioAnterior, "Tipo de residuo No valorizable"),
        {
            text: "Siglas", alignment: "left", decoration: "underline", italics: true, margin: [50, 20, 40, 0]
        },
        {
            text: "Multiplicación", alignment: "left", italics: true, margin: [50, 20, 40, 0]
        },
        {
            text: "Nota: Los factores de conversión incluidos en este cuadro para obtener las equivalencias son un valor de referencia.",
            alignment: "left",
            italics: true,
            margin: [50, 0, 40, 20]
        },
        informe.justificacionReduccion2022(datos.justResiduosNo, "#8db3e2", "Justificación en caso de: 1) aumento en la generación de residuos, 2) misma generación del año anterior, 3) ausencia de datos o 4) datos igual a cero:"),
        informe.tablaEvidencias(datos.docsJustReduccionNoValor),
        informe.comparacionConsumo2025(datos.consumoNoValolActual, constantes.indicadorResiduosNoValorizables, datos.consumoNoValoAnterior, `Comparación de generación residuos no valorizables del año ${anio}`, '28-B', datos.justResiduosNo, "Justificación en caso de no lograrse la reducción, ausencia de datos:"),
        informe.tablaEvidencias(datos.docsJustReduccionNoValor),
        {
            pageBreak: "before",
            text: "6.7. Trazabilidad de la gestión de residuos de manejo especial",
            alignment: "justify",
            bold: true,
            margin: [50, 0, 40, 0]
        },
        {
            text: "Cuadro N°29",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 20]
        },
        {
            text: `Trazabilidad de la gestión de residuos de manejo especial ${anio}`,
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 0]
        },
        informe.residuosEspecialesTraz25(datos.residuosEspeciales, "Descripción de la trazabilidad del residuo"),
        informe.justificacion(datos.justifResidEspeciales, "Justificación detallada en caso de ausencia de datos (espacios en blanco) o indicar que no generan algún tipo de residuo de manejo especial:"),
        {
            text: "", alignment: "left", bold: true, margin: [50, 20, 40, 20]
        },
        //informe.nombreimagen(datos.residuosEspeciales, 'Nombre de Evidencia'),
        informe.evidEspecialesTraz22(datos.residuosEspecialesEvid),
        {
            pageBreak: "before",
            text: "6.8. Trazabilidad de la gestión de residuos peligrosos",
            alignment: "justify",
            bold: true,
            margin: [50, 0, 40, 0]
        },
        {
            text: "Cuadro N°30",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 20]
        },
        {
            text: `Trazabilidad de la gestión de residuos peligrosos ${anio}`,
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 0]
        },
        informe.residuosEspecialesTraz25(datos.residuosPeligrosos, "Descripción de la trazabilidad de la gestión"),
        {
            text: "", alignment: "left", bold: true, margin: [50, 20, 40, 20]
        },
        informe.justificacion(datos.justifResidPeligrosos, "Justificación en caso de ausencia de datos o espacios en blanco en este apartado. Si indican que no generan residuos peligrosos, brindar explicación detallada del por qué consideran que no lo generan"),
        {
            text: "", alignment: "center", bold: true, margin: [50, 20, 40, 0]
        },
        informe.evidEspecialesTraz22(datos.residuosPeligrososEvid),
        {
            pageBreak: "before",
            text: "6.9. Educación Ambiental", alignment: "justify", bold: true, margin: [50, 0, 40, 0]
        },
        {
            text: "Cuadro N°31",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 20]
        },
        {
            text: `Educación Ambiental ${anio}`,
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 0]
        },
        informe.educacionAmbiental2023(datos.educacionResiduos),
        {
            pageBreak: "before",
            text: "6.10. Acciones de registro, reducción y control (Una acción)", alignment: "justify", bold: true, margin: [50, 0, 40, 0]
        },
        {
            text: "Cuadro N°32",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 20]
        },
        {
            text: `Acción de registro, reducción y control`,
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 0]

        },
        informe.tablaAccionesReduccion2022(datos.accionReduccionResiduos),
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        {
            pageBreak: "before",
            text: "Parámetro N°7: Gases Refrigerantes ",
            alignment: "center",
            bold: true,
            margin: [50, 20, 40, 0],
            fontsize: 18,
            color: "#4f81bd"
        },
        {
            text: "7.1. Inventario de equipos que consumen gases refrigerantes",
            alignment: "left",
            bold: true,
            margin: [50, 20, 40, 0]
        },
        {
            text: "Cuadro N°33-a",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 0]
        },
        {
            text: 'Inventarios de equipos que consumen gases refrigerantes',
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 15],
        },
        informe.inventarioContam22(datos.inventarioContAtmos, anio, anioAnterior),
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        informe.gasesRefCasoSinInv25(datos.inventarioContAtmos, datos.educacionAmbientalCaso2, datos.accionReduccionCaso2),
        {
            pageBreak: "before",
            text: "7.2. Educación Ambiental (Una actividad) ", alignment: "justify", bold: true, margin: [50, 0, 40, 0]
        },
        {
            text: "Cuadro N°34",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 0]
        },
        {
            text: `Educación Ambiental`,
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 15]
        },
        informe.educacionAmbiental2025(datos.educaGases),
        {
            pageBreak: "before",
            text: "7.3 Acciones de registro, reducción y control (Una acción)",
            alignment: "justify",
            bold: true,
            margin: [50, 0, 40, 0]
        },
        {
            text: "Cuadro N°35",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 0]
        },
        {
            text: `Acción de registro, reducción y control`,
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 20]
        },
        informe.tablaAccionesReduccion2025(datos.accionReduccionContAtmos),
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        {
            pageBreak: "before",
            text: "8. Compras Sostenibles", alignment: "center", bold: true, margin: [50, 20, 40, 0]
        },
        {
            text: "8.1 Criterios de compras sostenibles en ejecución, que permita a la empresa un consumo ambiental y socialmente responsable",
            alignment: "justify",
            bold: true,
            margin: [50, 20, 40, 0]
        },
        {
            text: "", alignment: "center", bold: true, margin: [50, 20, 40, 0]
        },
        informe.criteSotenibles22(datos.programaCompSostEvid),
        {
            text: "", alignment: "center", bold: true, margin: [50, 20, 40, 0]
        },
        informe.comprasSotenibles22(datos.programaCompSost),
        {
            pageBreak: "before",
            text: "8.2. Productos adquiridos aplicando los criterios de compras sostenibles establecidos en la organización",
            alignment: "justify",
            bold: true,
            margin: [50, 20, 40, 20]
        },
        {
            text: "Cuadro N°36-a",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 20]
        },
        {
            text: `Productos adquiridos aplicando los criterios de compras sostenibles ${anio}`,
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 0]
        },
        informe.inventCompSost22(datos.productosSost),
        {
            text: "", alignment: "left", bold: true, margin: [50, 20, 40, 20]
        },
        informe.comprasSostenibles2025(datos.productosSost),
        {
            text: "", alignment: "left", bold: true, margin: [50, 20, 40, 20]
        },
        {
            text: "Cuadro N°36-b",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 20]
        },
        {
            text: `Educación Ambiental o Acción de Reducción y control`,
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 0]
        },
        {
            text: `(Actividad para sedes que no adquirieron productos aplicando criterios de compras sostenibles)`,
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 0]
        },
        informe.educReducc(datos.educacionCompras, datos.reduccionCompras),
        {
            pageBreak: "before",
            text: "Parámetro N°9: Adaptación al Cambio Climático ",
            alignment: "center",
            bold: true,
            margin: [50, 20, 40, 0],
            fontSize: 16,
            color: "#4f81bd",
        },
        {
            text: "9.1 Identificación de las amenazas climáticas a las que está expuesta la sede y sus partes interesadas",
            alignment: "justify",
            bold: true,
            margin: [50, 20, 40, 0]
        },
        {
            text: "Cuadro N°37",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 0]
        },
        {
            text: "Identificación de las amenazas climáticas",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 15]
        },
        informe.tablaAmenazaClimatica25(datos.amenazas),
        {
            pageBreak: "before",
            text: "Escala de valoración de la exposición", alignment: "left", bold: true, margin: [0, 5, 40, 15]
        },
        informe.tablaEscalaValoracion(datos.escalas),
        {
            pageBreak: "before",
            text: "9.2 Identificación de los impactos para la organización y sus partes interesadas debido al cambio climático.",
            alignment: "justify",
            bold: true,
            margin: [50, 20, 40, 0]
        },
        {
            text: "Cuadro N°38",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 0]
        },
        {
            text: "Acciones en adaptación ante al cambio climático",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 15]
        },
        informe.tablaImpactos2025(datos.impactos),
        {
            pageBreak: "before",
            text: "9.3 Implementación de acciones de adaptación (Dos acciones)  ",
            alignment: "justify",
            bold: true,
            margin: [50, 20, 40, 0]
        },
        {
            text: "Cuadro N°39",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 0]
        },
        {
            text: "Acciones de adaptación implementadas o en proceso de implementación por la organización  ",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 15]
        },
        informe.accionesAdaptacion2025(datos.accionesAdaptacion),
        {
            pageBreak: "before",
            text: "9.4 Educación ambiental (Una actividad) ", alignment: "justify", bold: true, margin: [50, 20, 40, 0]
        },
        {
            text: "Cuadro N°40",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 0]
        },
        {
            text: "Educación ambiental",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 15]
        },
        informe.educacionAmbiental2025(datos.educacionAdaptacion),
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        {
            pageBreak: "before",
            text: "10. Compensación Ambiental", alignment: "center", bold: true, margin: [50, 20, 40, 0]
        },
        {
            text: "10.1 Actividad de compensación, con relación al impacto generado por la sede, en alguno de los parámetros antes citados.",
            alignment: "justify",
            bold: true,
            margin: [50, 20, 40, 0]
        },
        {
            text: "Cuadro N°41",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 20]
        },
        {
            text: "Actividad de compensación",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 0]
        },
        informe.actividadComponsacion26(datos.actividadesComp, datos.actividadesCompEvid, datos.actCompDispEvid),
        {
            pageBreak: "before",
            text: "10.2 Educación ambiental", alignment: "justify", bold: true, margin: [50, 20, 40, 0]
        },
        {
            text: "Cuadro N°42",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 20]
        },
        {
            text: "Educación ambiental",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 0]
        },
        informe.educacionAmbiental2023(datos.educacionCompensacion),
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        {
            pageBreak: "before",
            text: "Gradación de Estrellas",
            alignment: "left",
            bold: true,
            margin: [0, 20, 40, 20],
            color: "#4f81bd",
            fontSize: 16
        },
        {text: "Una estrella Blanca:", bold: true, alignment: "center", color: "#204768", margin: [0, 0, 0, 15]},
        {
            text: "La sede que logre un porcentaje anual del 90 al 100% de los parámetros obligatorios (apartados anteriores de este documento)",
            alignment: "justify",
            italics: true,
            margin: [50, 0, 40, 20]
        },
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        {text: "Dos Estrellas Blancas:", bold: true, alignment: "center", color: "#204768", margin: [0, 0, 0, 15]},
        {
            text: "Cuadro N°43",
            color: "#204768",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
        },
        {
            text: "Actividades o reconocimiento para optar por Dos estrellas blancas",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [0, 0, 0, 20]
        },
        informe.tablaEstrellaDos2025(datos.programasGest),
        informe.evidencia25(datos.programasGestEvid, "Evidencias (constancias, certificados, fotografías u otros) del programa de gestión interno o reconocimiento externo o iniciativa para promover la salud integral y la felicidad"),
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        {
            pageBreak: "before",
            text: "Tres estrellas blancas",
            bold: true,
            alignment: "center",
            color: "#204768",
            margin: [0, 0, 0, 15]
        },
        {
            text: "Cuadro N°44",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 0]
        },
        {
            text: "Actividades para incentivar y acompañar en PBAE (dentro cadena valor)",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 15]
        },
        informe.tablaEstrellaTres25(datos.promoPbaeCadVal),
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        {
            pageBreak: "before", text: "Cuatro estrellas blancas",
            bold: true,
            alignment: "center",
            color: "#204768",
            margin: [0, 0, 0, 15]
        },
        {
            text: "Cuadro N°45",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 0]
        },
        {
            text: "Actividades para incentivar y acompañar en PBAE (no vinculadas con cadena valor) para optar por Cuatro estrellas blancas",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 15]
        },
        informe.tablaEstrellaCuatro25(datos.promoPbaeComu),
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        {
            pageBreak: "before", text: "Cinco estrellas blancas",
            bold: true,
            alignment: "center",
            color: "#204768",
            margin: [0, 0, 0, 15]
        },
        {
            text: "Cuadro N°46",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 0]
        },
        {
            text: "Inventario emisiones y remociones de GEI para optar por Cinco estrellas blancas",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 15]
        },
        informe.tablaEstrellaCinco25(datos.inventarioGei),
        {
            text: " ",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 20]
        },
        informe.evideEstrella25(datos.inventarioGei, "Evidencia de la cuantificación", "Fotografías del reporte" +
            " o gráficos del inventario"),
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        {
            pageBreak: "before", 
            image: datos.orgaLogo, alignment: 'right', fit: [160, 80], margin: [0, 0, 40, 0]
        },
        {
            text: "Seis estrellas blancas",
            bold: true,
            alignment: "center",
            color: "#204768",
            margin: [0, 0, 0, 15]
        },
        {
            text: "Cuadro N°47",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 20, 40, 0]
        },
        {
            text: "Reconocimientos para optar por seis estrellas blancas",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 15]
        },
        informe.tablaEstrellaSeis26(datos.certCarbNeut),
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        { pageBreak: "before", pageOrientation: 'portrait',pageMargins: [20, 0, 0, 0],
          image: datos.orgaLogo, alignment: 'right', fit: [160, 80], margin: [0, 0, 40, 0]
        },
        {	  
          text: "Estrella Verde", bold: true, 
          color: "#244061",
          alignment: "center",
          fillColor: "#244061",
          fontSize: 14,
          margin: [50, 20, 40, 10]
        },
        {
          text: "Cuadro N°48",
          color: "#1f497d",
          alignment: "center",
          fillColor: "#1f497d",
          margin: [50, 0, 40, 0]
        },
        {
          text: "Se opta por Estrella Verde: Hogares Sostenibles",
          color: "#1f497d",
          alignment: "center",
          fillColor: "#1f497d",
          margin: [50, 0, 40, 10]
        },
        informe.tablaEstrellaVPN26(datos.notaHogares, 1),
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        {	  
            text: "Estrella Plateada", bold: true, 
            color: "#244061",
            alignment: "center",
            fillColor: "#244061",
            fontSize: 14,
            margin: [50, 20, 40, 10]
        },
        {
            text: "Cuadro N°49",
            color: "#4f81bd",
            alignment: "center",
            fillColor: "#4f81bd",
            italics: true,
            margin: [50, 0, 40, 0]
        },
        {
          text: "Se opta por estrella plateada: ecoins",
          color: "#1f497d",
          alignment: "center",
          fillColor: "#1f497d",
          margin: [50, 0, 40, 10]
        },
        informe.tablaEstrellaVPN26(datos.progEcolones, 2),
        {text: 'Recordar que para optar por esta estrela: ', alignment: 'left'},
        {text: '1. La sede debe tener cuenta Ecoins ', alignment: 'left'},
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        {
          text: "Estrella Anaranjada", bold: true, 
          color: "#244061",
          alignment: "center",
          fillColor: "#244061",
          fontSize: 14,
          margin: [50, 20, 40, 10]
        },
        
        {
          text: "Cuadro N°50",
          color: "#1f497d",
          alignment: "center",
          fillColor: "#1f497d",
          margin: [50, 0, 40, 0]
        },
        {
          text: "Sede opta por estrella anaranjada",
          color: "#1f497d",
          alignment: "center",
          fillColor: "#1f497d",
          italics: true,
          margin: [50, 0, 40, 10]
        },
        informe.tablaEstrellaVPN26(datos.actividadesNaranja, 3)
    
  ];//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  
  return content;
}